<template>
  <div class="create-target-modal__modal">
    <div v-if="!loading" class="create-target-modal__header-menu align-center" >
      <template v-if="svg">
        <svg-icon :icon="svg" :width="60" :height="60" class="create-target-modal__svg"></svg-icon>
      </template>
      <template v-else-if="png">
        <img :src="png" class="create-target-modal__svg create-target-modal__png"/>
      </template>
      <div class="text-h4 font-weight-medium">
        {{ title }}
      </div>
    </div>
    <div v-if="loading" class="create-target-modal__loading">
      <loading-dots></loading-dots>
    </div>
    <div :class="{
      'create-target-modal__invisible': loading
      }">
      <slot></slot>
      <template>
        <slot name="create"></slot>
      </template>
      <template>
        <slot name="select"></slot>
      </template>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import LoadingDots from '@/components/common/loaderDots'

export default {
  components: {
    SvgIcon,
    LoadingDots
  },
  props: {
    title: String,
    svg: Object,
    png: String,
    overrideLoad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loading () {
      return this.$store.state.createTarget.isLoading && !this.overrideLoad
    }
  }
}
</script>

<style lang="scss">
$CreateTargetBackgroundColor: color('grays', 'almost-white');
.create-target-modal {
  .modal__content {
    background-color: $CreateTargetBackgroundColor;
  }
  .create-target-form {
    background-color: $CreateTargetBackgroundColor;
    &__name-input {
      background-color: $CreateTargetBackgroundColor;
    }
  }
  &__svg {
    float: left;
    margin-right: 20px;
  }
  &__png {
    width: 60px;
    height: 60px;
  }
  &__header-menu {
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__right-header {
    float: right;
    margin-top: 30px;
    margin-right: 50px;
  }
  &__invisible {
    visibility: hidden;
  }
  &__loading {
    margin: 0 auto;
    width: 100px;
  }
}
</style>




// WEBPACK FOOTER //
// CreateTargetSlot.vue?1a82847f